export default class SurveyCategoryItemInstruction {
  public idSurveyCategoryItemInstruction: number = 0;
  public idSurveyCategoryItem: number = 0;
  public categoryItemInstruction: string = "";
  public index: number = 0;
}
